import { configureStore } from '@reduxjs/toolkit';
import depositReducer from './slices/depositSlice';
import withdrawReducer from './slices/withdrawSlice';
import kycReducer from './slices/kycSlice';
import userReducer from './slices/userSlice';

export const store = configureStore({
    reducer: {
        deposit: depositReducer,
        withdraw: withdrawReducer,
        kyc: kycReducer,
        user: userReducer,
    },
});
